import React, { MouseEventHandler, ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import Tooltip from 'components_new/atoms/Tooltip'

interface InfoButtonProps {
  className?: string
  onClick?: MouseEventHandler<HTMLElement>
  onMouseDown?: MouseEventHandler<HTMLElement>
  sx?: SxProps
  title: ReactNode
  variant?: 'data' | 'default'
}

/** The information icon beside a metric, so every one looks the same. */
const InfoButton = (props: InfoButtonProps) => {
  const { className, onClick, onMouseDown, sx, title, variant } = props

  return (
    <Tooltip title={title} variant={variant}>
      <IconButton
        className={className}
        onClick={onClick}
        onMouseDown={onMouseDown}
        size="small"
        sx={sx}
      >
        <Icon color="disabled" fontSize="inherit" name="Info" />
      </IconButton>
    </Tooltip>
  )
}

export default InfoButton
